import axios from 'axios';

axios.defaults.url = process.env.PUBLIC_URL;
